// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/modern/" + "focus-visible" + "." + "419ae3db" + ".js";
};